import { getCountryOverallTrend } from 'Utils/calcOverallTrend';
import maxBy from 'lodash/maxBy';

const defaultSmartText = {
  increasing: 'COVID-19 infections are increasing in {{ country }}, with **{{ cases }}** new infections reported on average each day. That’s {{ percent }} of the peak — the highest daily average reported on {{ date }}.',
  decreasing: 'COVID-19 infections are decreasing in {{ country }}, with **{{ cases }}** new infections reported on average each day. That’s {{ percent }} of the peak — the highest daily average reported on {{ date }}.',
  neither: '{{ country }} is reporting **{{ cases }}** new infections on average each day, {{ percent }} of the peak — the highest daily average reported on {{ date }}.',
  increasingAtPeak: 'COVID-19 infections in {{ country }} are at their peak — the highest daily average reported — and still increasing, now at **{{ cases }}** new infections reported each day.',
  decreasingAtPeak: 'COVID-19 infections in {{ country }} are still at their peak — the highest daily average reported — but now decreasing, falling to **{{ cases }}** new infections reported each day.',
  neitherAtPeak: 'COVID-19 infections in {{ country }} are at their peak — the highest daily average reported — now at **{{ cases }}** new infections reported each day.',
};

const getAverages = (array, lag = 7) => array
  .slice(7 - 1)
  .map((d, i) => array.slice(i, i + 7))
  .map((slice) => {
    if (slice.includes(null)) return null;
    const mean = slice.reduce((a, d) => a + d.count, 0) / 7;
    return {
      mean,
      date: slice.slice(-1)[0].date,
    };
  });

const getLatestDaily = (globalStatistics, caseCounts, country, locale, smartText = defaultSmartText) => {
  const trends = getCountryOverallTrend(globalStatistics, country.isoAlpha2);
  const percent = globalStatistics.distributionRanks.cases[country.isoAlpha2];
  const atPeak = globalStatistics.distributionRanks.cases[country.isoAlpha2] > 0.99;
  const dailyAvgs = getAverages(caseCounts);
  const maxDate = new Date(maxBy(dailyAvgs, d => d.mean).date);
  const date = maxDate.toLocaleString(locale, { month: 'long', day: 'numeric' });

  const lastCaseAvg = Math.floor(globalStatistics.latestWeeklyAvgs.cases[country.isoAlpha2].slice(-1)[0]);

  const context = {
    country: country.translations[locale],
    cases: lastCaseAvg.toLocaleString(locale),
    percent: `${Math.round(percent * 100)}%`,
    date,
  };

  if (atPeak) {
    if (trends.cases.increasingAtPeak) {
      return {
        source: smartText.increasing,
        context,
      };
    }

    if (trends.cases.decreasingAtPeak) {
      return {
        source: smartText.decreasing,
        context,
      };
    }

    return {
      source: smartText.neitherAtPeak,
      context,
    };
  }

  if (trends.cases.increasing) {
    return {
      source: smartText.increasing,
      context,
    };
  }

  if (trends.cases.decreasing) {
    return {
      source: smartText.decreasing,
      context,
    };
  }

  return {
    source: smartText.neither,
    context,
  };
};

export default getLatestDaily;
